import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { entitiesActions } from '@/store/entities';
import { getErrorMessage } from '@/utils/helpers';
import { useTranslation } from 'react-i18next';

export const usePopups = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showSuccessToast = useCallback((text) => {
    dispatch(entitiesActions.addToastSuccess(t(text)));
  }, [dispatch]);

  const showErrorToast = useCallback((e, needErrorMessage = false) => {
    dispatch(entitiesActions.addToastError(t(needErrorMessage ? getErrorMessage(e) : e)));
  }, [dispatch]);

  const showInfoToast = useCallback((e, needErrorMessage = false) => {
    dispatch(entitiesActions.addToastInfo(t(needErrorMessage ? getErrorMessage(e) : e)));
  }, [dispatch]);

  const showLoader = useCallback((text = 'Processing') => {
    dispatch(entitiesActions.showLoader(t(text) + '...'));
  }, [dispatch]);

  const hideLoader = useCallback(() => {
    dispatch(entitiesActions.hideLoader());
  }, [dispatch]);

  return {
    showSuccessToast,
    showErrorToast,
    showInfoToast,
    showLoader,
    hideLoader
  };
};
